﻿import {Controller} from "./helpers/controller";
import {shim} from "./helpers/shim";
import {onResize} from "./helpers/resize";
import {centerListing} from "./findCenterControl";
import {Flickity} from "./utils/loadFlickity";

export class CarouselControl extends Controller {

    private timer: number | undefined;
    private title: string = '';
    private flickityInstance: any;
    private windowWidth: number = 0;
    private flickity: Flickity = new Flickity();

    constructor(element: HTMLElement) {
        super(element);

        this.flickity.loadScript(this.loadFlickity);

        onResize(this.onWindowResize, 200);
    }
    
    onWindowResize = () => {
        if (this.windowWidth == window.innerWidth) {
            return;
        }
        this.windowWidth = window.innerWidth;
        this.reloadFlickity();
    }

    
    loadFlickity = () => {
        let flickity = shim('Flickity');
        let showPageDots = this._element.hasAttribute('data-carousel-dots');
        let showPrevNextButons = showPageDots ? false : !this._element.hasAttribute('data-carousel-clean');

        var carouselElement = this.$();
        var carouselItems = carouselElement.children();
        if (carouselElement.width() < (carouselItems.first().innerWidth() * (carouselItems.length))) {
            this.flickityInstance = new flickity(this._element, {
                cellAlign: 'left',
                contain: true,
                pageDots: showPageDots,
                prevNextButtons: showPrevNextButons
            });
        }
    }
    
    reloadFlickity = () => {
        if (this.flickityInstance) {
            this.flickityInstance.destroy();
        }
        this.loadFlickity();
    }
}

